import {createSlice} from '@reduxjs/toolkit';

const SupportedTVSlice = createSlice({
  name: 'supportedTV',
  initialState: {
    show: false,
    togglePopover: false,
  },

  reducers: {
    displaySupportedTV: {
      reducer(state, action) {
        state.show = action.payload;
      },
    },
    openPopover: {
      reducer(state, action) {
        if (state.togglePopover === false) {
          state.togglePopover = true;
        } else {
          state.togglePopover = false;
        }
      },
    },
    closePopover: {
      reducer(state, action) {
        if (state.togglePopover === true) {
          state.togglePopover = false;
        }
      },
    },
  },
});

export const {displaySupportedTV, openPopover, closePopover} = SupportedTVSlice.actions;

export default SupportedTVSlice.reducer;
